var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDesktopLinkIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon desktop-icon",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0a1 1 0 011 1v12a1 1 0 01-1 1h-6.5v2.5h1.75a.75.75 0 010 1.5h-8.5a.75.75 0 010-1.5H7.5V14H1a1 1 0 01-1-1V1a1 1 0 011-1h18zm-.5 1.5h-17v11h17v-11z"
  })));
}

export default SvgDesktopLinkIconSv;